import 'css-chunksrc/client/scenes/list/timestamp/datesPickers/styles.scss';export default {
  "datesWrapper": "_datesWrapper_hzgqn_1",
  "group": "_group_hzgqn_9",
  "title": "_title_hzgqn_16"
};